// import { useContext } from 'react';
import { useContext } from 'use-context-selector';
import { CartContext } from 'Contexts/CartContext';

export default function useCart() {
  return useContext(CartContext);
}
